import script from "./ModelagemReajustes.vue?vue&type=script&setup=true&lang=js"
export * from "./ModelagemReajustes.vue?vue&type=script&setup=true&lang=js"

import "./ModelagemReajustes.vue?vue&type=style&index=0&id=00c71f97&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-00c71f97"]])

export default __exports__